export const CHECKOUT_URL = 'https://abg-en.impultienda.ar/checkout/';

export const images = {
  mockup: 'https://cdn.magicpatterns.com/uploads/cCFvc1nThUfyesA8vVtvV5/MOCKUP_ABG-EN.png',
  rachel: 'https://cdn.magicpatterns.com/uploads/o6UZBEmYgEqVVNUbT3w4pX/Rachel_Bennett_-_NURSING.png',
};

export const valueStack = [
  { label: 'ABG Clinical Roadmap™ — 6 Educational Volumes', value: 162, main: true },
  { label: 'Bonus #1 — The ABG Quick-Reference Cards', value: 17, main: false },
  { label: 'Bonus #2 — The 10-Minute ABG Study Review', value: 12, main: false },
  { label: 'Bonus #3 — The ABG Interpretation Pitfalls Library', value: 17, main: false },
  { label: 'Bonus #4 — The ABG Clinical Case Practice Expansion Pack', value: 17, main: false },
  { label: 'Bonus #5 — The ABG Learning Progress Checklist Collection', value: 12, main: false },
];

export const offerChecks = [
  'Six educational volumes',
  'Five specialized bonuses',
  'Organized reference tables and worksheets',
  'Educational case exercises',
  'No monthly subscription',
  'Digital access to the purchased materials',
];

export const finalIncludes = [
  'Six educational volumes',
  'Five specialized study bonuses',
  'ABG reference tables and comparison tools',
  'Practical worksheets and checklists',
  'Simulated educational case exercises',
  'Structured knowledge-review resources',
];
